import { SetData as UseCaseReduxSetData } from '~/domain/usecases/appointment/redux';

import { ReduxSetData } from '~/data/store/reducer/appointment/usecases/ReduxSetData';

export const makeReduxSetData = (): UseCaseReduxSetData => new ReduxSetData();
